import { render } from "./TermsArabic.vue?vue&type=template&id=2bdad0f0"
import script from "./TermsArabic.vue?vue&type=script&lang=js"
export * from "./TermsArabic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__